export default __webpack_public_path__ + "static/media/Theme9.6b12d8c8.png";